// extracted by mini-css-extract-plugin
module.exports = {"SocialIcons":"FollowUs_SocialIcons__w85w0","Title":"FollowUs_Title__EgejH"};